import React from 'react';
import { Save, CheckCircle, Clock } from 'lucide-react';
import { Button } from '../ui/button';
import { toast } from 'sonner';
import { Input } from '../ui/input';

const FormField = ({ label, value, onChange, type = 'text', icon: Icon, className = '', placeholder = '' }) => (
  <div className={`bg-white/5 border border-white/10 rounded-lg p-4 ${className}`}>
    <label className="text-white/50 text-sm block mb-2 flex items-center gap-2">
      {Icon && <Icon className="w-4 h-4" />}
      {label}
    </label>
    <Input
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="bg-white/5 border-white/10 text-white"
      placeholder={placeholder}
    />
  </div>
);

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const StatsTab = ({ stats, setStats, saveStats, getStoredPassword }) => {
  const toggleEnabled = async () => {
    const newEnabled = stats.enabled === false ? true : false;
    const newStats = {...stats, enabled: newEnabled};
    setStats(newStats);
    try {
      const response = await fetch(`${API_URL}/api/admin/stats?password=${getStoredPassword()}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newStats)
      });
      if (response.ok) toast.success(newEnabled ? 'Stats visible' : 'Showing "Coming Soon"');
    } catch (e) {
      toast.error('Failed to update');
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-lg text-white">Site Statistics</h3>
          <p className="text-white/50 text-sm">These stats are displayed in the Impact section on the homepage.</p>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-white/50 text-sm">{stats.enabled !== false ? 'Visible' : 'Coming Soon'}</span>
          <button
            onClick={toggleEnabled}
            data-testid="stats-section-toggle"
            className={`relative w-12 h-6 rounded-full transition-colors ${
              stats.enabled !== false ? 'bg-green-500' : 'bg-[#D4AF37]'
            }`}
          >
            <span className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform ${
              stats.enabled !== false ? 'left-7' : 'left-1'
            }`} />
          </button>
        </div>
      </div>
      
      <div className={`${stats.enabled === false ? 'opacity-50' : ''}`}>
        <div className="grid grid-cols-2 gap-4">
          <FormField label="Properties Acquired" value={stats.properties_acquired} onChange={(v) => setStats({...stats, properties_acquired: parseInt(v) || 0})} type="number" />
          <FormField label="Capital Deployed (£M)" value={stats.capital_deployed} onChange={(v) => setStats({...stats, capital_deployed: parseInt(v) || 0})} type="number" />
          <FormField label="Average ROI (%)" value={stats.average_roi} onChange={(v) => setStats({...stats, average_roi: parseInt(v) || 0})} type="number" />
          <FormField label="Investors Served" value={stats.investors_served} onChange={(v) => setStats({...stats, investors_served: parseInt(v) || 0})} type="number" />
        </div>
      </div>
      
      <div className="flex items-center gap-4">
        <Button onClick={saveStats} className="bg-[#D4AF37] text-black hover:bg-[#B8941E]" data-testid="save-stats-btn">
          <Save className="w-4 h-4 mr-2" /> Save Changes
        </Button>
        <div className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs ${
          stats.enabled !== false ? 'bg-green-500/20 text-green-400' : 'bg-[#D4AF37]/20 text-[#D4AF37]'
        }`}>
          {stats.enabled !== false ? (
            <><CheckCircle className="w-3 h-3" /> Stats visible on site</>
          ) : (
            <><Clock className="w-3 h-3" /> Showing "Coming Soon"</>
          )}
        </div>
      </div>
    </div>
  );
};
